import {environment} from '../../environments/environment';

import {BrowserCacheLocation, Configuration, LogLevel,} from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.auth.clientId,
    authority: `https://login.microsoftonline.com/${environment.auth.tenantId}`,
    redirectUri: environment.auth.redirectUri,
    postLogoutRedirectUri: environment.auth.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.debug('[MSAL]', logLevel, message);
        // throw new Error(`[MSAL] ${logLevel} ${message}`);
      },
      piiLoggingEnabled: false,
    },
  },
};

export const protectedResourceMap = new Map<string, Array<string>>([
  [environment.auth.apiBaseUrl, [environment.auth.scopeApi]],
]);
